// extracted by mini-css-extract-plugin
export var completionBody = "_cp-2";
export var completionCard = "_cp-0";
export var completionFooter = "_cp-3";
export var completionTitle = "_cp-1";